export default "__VITE_ASSET__DJpLtCx7__"